import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: any = {
  journeyType: '',
  conversationId: null as string | null,
};

const cdpDataSlice = createSlice({
  name: 'cdpData',
  initialState,
  reducers: {
    storeCDPData: (_state, action: PayloadAction<any>) => ({
      ..._state,
      ...action.payload,
    }),
    resetCDPData: (_state) => ({
      journeyType: _state.payload,
    }),
    addJourneyType: (_state, action: PayloadAction<string>) => ({
      ..._state,
      journeyType: action.payload,
    }),
    setConversationId: (_state, action: PayloadAction<string | null>) => ({
      ..._state,
      conversationId: action.payload,
    }),
  },
});

export const { storeCDPData, addJourneyType, resetCDPData, setConversationId } =
  cdpDataSlice.actions;
export default cdpDataSlice.reducer;
